<template>
  <div class="relative z-50">
    <nav class="relative z-10 grid grid-cols-5">
      <router-link
        v-for="link in priorityLinks"
        :key="link.title"
        :to="link.url"
        :exact="link.title == 'Dashboard'"
        class="btn"
      >
        <i v-html="link.icon"></i>
        <span class="text-[10px]"> {{ link.title }} </span>
      </router-link>
      <button
        class="btn"
        :class="[
          { 'text-gray-400': !menu_is_active },
          { '!bg-ontick-carbon-500': menu_is_active },
        ]"
        @click="menu_is_active = !menu_is_active"
      >
        <i
          v-html="$icons.menu"
          class="flex h-[18px] items-center justify-center overflow-visible"
          :class="{ 'text-ontick-blue-600': menu_is_active }"
        ></i>
        <span class="text-[10px]"> Menu </span>
      </button>
    </nav>
    <transition
      enter-active-class="transform transition ease-in-out duration-300 sm:duration-500"
      enter-class="translate-y-full"
      enter-to-class="translate-y-0"
      leave-active-class="transform transition ease-in-out duration-300 sm:duration-500"
      leave-class="translate-y-0"
      leave-to-class="translate-y-full"
    >
      <nav
        class="bg-ontick-carbon-500 divide-ontick-steel-500 fixed inset-0 divide-y-2 overflow-y-auto px-6 pt-12 pb-32"
        v-if="menu_is_active"
      >
        <div class="space-y-2 pb-4">
          <dashboard-account-select-component />
        </div>
        <div class="space-y-2 py-4">
          <ul class="flex w-full flex-col">
            <template v-for="link in nav">
              <li v-if="link.visible" :key="link.title">
                <router-link
                  class="flex w-full items-center gap-4 py-2"
                  :to="link.url"
                  :exact="link.title == 'Dashboard'"
                >
                  <i v-html="link.icon" class="h-5 w-5"></i>
                  <span>
                    {{ link.title }}
                  </span>
                </router-link>
              </li>
            </template>
            <li>
              <button
                class="flex w-full items-center gap-4 py-2 text-gray-400"
                @click="partners_tab_is_active = !partners_tab_is_active"
              >
                <span
                  class="flex h-5 w-5 items-center justify-center overflow-visible"
                >
                  <i
                    v-html="$icons.person_check"
                    class="flex h-5 w-5 items-center justify-center overflow-visible"
                  ></i>
                </span>
                <span> Parceiros ativados </span>
              </button>
            </li>
            <li>
              <router-link
                class="flex w-full items-center gap-4 py-2"
                to="/account?tag=profile"
              >
                <i
                  v-html="$icons.profile"
                  class="flex h-5 w-5 items-center justify-center overflow-visible"
                ></i>
                <span> Preferências </span>
              </router-link>
            </li>
            <li>
              <a
                class="flex w-full items-center gap-4 py-2"
                href="https://ajuda.ontick.com.br"
                target="_blank"
              >
                <i
                  v-html="$icons.help"
                  class="flex h-5 w-5 items-center justify-center overflow-visible"
                ></i>
                <span> Ajuda </span>
              </a>
            </li>
          </ul>
        </div>
        <div class="space-y-2 py-4">
          <button
            class="flex w-full items-center gap-4 py-2 text-gray-400"
            @click="signOut()"
          >
            <span
              class="flex h-5 w-5 items-center justify-center overflow-visible"
            >
              <i
                v-html="$icons.logout"
                class="flex h-5 w-5 items-center justify-center overflow-visible"
              ></i>
            </span>
            <span> Sair </span>
          </button>
        </div>
      </nav>
    </transition>
    <ontick-aero-component
      :active="partners_tab_is_active"
      @close="partners_tab_is_active = false"
    >
      <div class="bg-ontick-graphite-500 space-y-6 p-6">
        <span class="font-semibold"> Parceiros ativados </span>
        <nav>
          <ul>
            <li
              v-for="extension in extensions"
              :key="extension.extension_id"
              @click="goToPartner"
            >
              <router-link
                class="flex w-full items-center gap-4 py-2"
                :to="{
                  name: 'Estratégias de parceiro',
                  params: {
                    partner_name: extension.extension_path,
                    extension_id: extension.extension_id,
                  },
                }"
              >
                <img
                  :src="extension.extension_logo"
                  :alt="extension.extension_name"
                  class="h-5 w-5"
                />
                <span>
                  {{ extension.extension_name }}
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </ontick-aero-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DashboardAccountSelectComponent from "../../../../modules/dashboard/components/dashboard-account-select.component.vue";
import OntickAeroComponent from "../../basic/ontick-aero.component.vue";
import { Auth } from "aws-amplify";

export default {
  components: {
    DashboardAccountSelectComponent,
    OntickAeroComponent,
  },
  props: {
    nav: {
      type: Array,
    },
  },

  data() {
    return {
      menu_is_active: false,
      partners_tab_is_active: false,
    };
  },

  computed: {
    ...mapGetters({ getExtensions: "config/getExtensions" }),
    priorityLinks() {
      return this.nav.filter((item) =>
        ["Dashboard", "Estratégias", "Investimentos", "Parceiros"].includes(
          item.title
        )
      );
    },
    extensions() {
      let arr = [];
      if (this.getExtensions) {
        this.getExtensions.forEach((item) => {
          item.extensions.forEach((extension) => {
            arr.push({
              extension_name:
                item.extensions.length === 1
                  ? item.extension_owner
                  : extension.extension_name,
              extension_id: extension.extension_id,
              extension_path: item.extension_path,
              extension_logo: extension.extension_logo,
            });
          });
        });
      }
      return arr;
    },
  },

  methods: {
    goToPartner() {
      this.partners_tab_is_active = false;
      this.menu_is_active = false;
    },
    async signOut() {
      try {
        await Auth.signOut();
        this.worker.sendMessage({ type: "DISCONNECT" });
        sessionStorage.logout = true;
        this.$router.push({ path: "/auth" });
      } catch (error) {
        this.$swal("Error", error.message, "error");
      }
    },
  },

  watch: {
    "$route.name": {
      handler(val) {
        this.menu_is_active = false;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.btn {
  @apply bg-ontick-graphite-500 flex h-16 flex-col items-center justify-center gap-1.5 active:brightness-75;
}
a:not(.active) {
  @apply text-gray-400;
}
a.active i {
  @apply text-ontick-blue-600;
}
</style>
